import { render, staticRenderFns } from "./UrlEditor.vue?vue&type=template&id=0ba4e527&"
import script from "./UrlEditor.vue?vue&type=script&lang=ts&"
export * from "./UrlEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports